const firebaseConfig = {
    apiKey: "AIzaSyBmikzfhLLc-bI8tSHTTgF9TAQBslpAtzg",
    authDomain: "nusrat-jahan-nisha-wa-messages.firebaseapp.com",
    databaseURL: "https://nusrat-jahan-nisha-wa-messages.firebaseio.com",
    projectId: "nusrat-jahan-nisha-wa-messages",
    storageBucket: "nusrat-jahan-nisha-wa-messages.appspot.com",
    messagingSenderId: "943811240520",
    appId: "1:943811240520:web:a843825ceb0c2d4a496e7d"
  };
  
  export default firebaseConfig;